import { render } from "./ModalCreaPresenza.vue?vue&type=template&id=672d4355&scoped=true"
import script from "./ModalCreaPresenza.vue?vue&type=script&lang=js"
export * from "./ModalCreaPresenza.vue?vue&type=script&lang=js"

import "./ModalCreaPresenza.vue?vue&type=style&index=0&id=672d4355&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672d4355"]])

export default __exports__